// extracted by mini-css-extract-plugin
module.exports = {"footer":"style_footer__iEKF7","footerFullWidth":"style_footerFullWidth__7hv2N","inner":"style_inner__GL_8g","logo":"style_logo__2nnTG"};